import { render } from "./LegacyNewAction.vue?vue&type=template&id=163a8928"
import script from "./LegacyNewAction.vue?vue&type=script&lang=js"
export * from "./LegacyNewAction.vue?vue&type=script&lang=js"
script.render = render

export default script